<mat-card data-at-installations-migration-modal-confirmation>
  <mat-card-title data-at-installations-migration-modal-header>{{
    '+INSTALLATIONS_MIGRATION.HEADER' | translate
  }}</mat-card-title>
  <mat-card-content class="flex flex-col">
    <div
      class="customer-numbers-container flex flex-row lt-md:flex-col lt-md:gap-[12px] justify-around items-center"
    >
      <div
        class="customer-number flex flex-col justify-start items-stretch lt-md:items-center flex-[40%] max-w-[40%] lt-md:flex-[100%] lt-md:max-w-[100%]"
      >
        <span class="customer-number-label">{{
          '+MIGRATION.INPUT.CUSTOMER_NUMBER' | translate
        }}</span>
        {{ installationsMigrationStore.customerNumber$ | async }}
        <span>{{ installationsMigrationStore.customerCompanyName$ | async }}</span>
      </div>
      <div
        class="customer-number flex flex-col justify-start items-stretch lt-md:items-center flex-[40%] max-w-[40%] lt-md:flex-[100%] lt-md:max-w-[100%]"
      >
        <span class="customer-number-label">{{
          '+MIGRATION.INPUT.CUSTOMER_NUMBER_NEW' | translate
        }}</span>
        {{ installationsMigrationStore.newCustomerNumber$ | async }}
        <span>{{ installationsMigrationStore.newCustomerCompanyName$ | async }}</span>
      </div>
    </div>

    <div data-at-installations-migration-modal-description class="migration__description">
      {{
        '+INSTALLATIONS_MIGRATION.CONFIRMATION-TEXT'
          | translate
            : {
                count: getInstallationsCount(
                  installationsMigrationStore.installationsToMigrate$ | async
                )
              }
      }}
    </div>
  </mat-card-content>

  <mat-card-actions class="mat-card-actions">
    <!-- desktop view    -->
    <div class="lt-md:!hidden flex flex-row gap-[8px] justify-between items-center">
      <button
        data-at-installations-migration-btn-back
        class="lt-md:flex-[20%] lt-md:max-w-[20%]"
        mat-button
        color="primary"
        (click)="onBack()"
        gtm="onBackDialog"
        gtmAction="To 2st step"
        gtmCategory="migrateInstallation"
      >
        {{ 'GENERAL.BUTTON.BACK' | translate }}
      </button>
      <div>
        <button
          data-at-installations-migration-btn-cancel
          class="lt-md:flex-[20%] lt-md:max-w-[20%]"
          mat-button
          color="primary"
          (click)="onClose()"
          gtm="onCancel"
          gtmAction="Migrating installations"
          gtmCategory="migrateInstallation"
        >
          {{ 'GENERAL.BUTTON.CANCEL' | translate }}
        </button>

        <button
          data-at-installations-migration-btn-yes-migrate
          (click)="onMigrateInstallations()"
          mat-raised-button
          color="primary"
          gtm="onConfirm"
          gtmAction="Migration of installations"
          gtmCategory="migrateInstallation"
        >
          {{ '+INSTALLATIONS_MIGRATION.BTN.YES_MIGRATE' | translate }}
        </button>
      </div>
    </div>

    <!-- mobile view -->
    <div class="flex flex-col gap-[8px] gt-sm:!hidden justify-between items-center">
      <div>
        <button
          data-at-installations-migration-btn-back
          class="lt-md:flex-[20%] lt-md:max-w-[20%]"
          mat-button
          color="primary"
          (click)="onBack()"
          gtm="onBackDialog"
          gtmAction="To 2st step"
          gtmCategory="migrateInstallation"
        >
          {{ 'GENERAL.BUTTON.BACK' | translate }}
        </button>
        <button
          data-at-installations-migration-btn-cancel
          class="lt-md:flex-[20%] lt-md:max-w-[20%]"
          mat-button
          color="primary"
          (click)="onClose()"
          gtm="onCancel"
          gtmAction="Migrating installations"
          gtmCategory="migrateInstallation"
        >
          {{ 'GENERAL.BUTTON.CANCEL' | translate }}
        </button>
      </div>

      <button
        data-at-installations-migration-btn-yes-migrate
        (click)="onMigrateInstallations()"
        mat-raised-button
        color="primary"
        gtm="onConfirm"
        gtmAction="Migration of installations"
        gtmCategory="migrateInstallation"
      >
        {{ '+INSTALLATIONS_MIGRATION.BTN.YES_MIGRATE' | translate }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>
